import { render, staticRenderFns } from "./preview-address.vue?vue&type=template&id=5dd68118&"
import script from "./preview-address.vue?vue&type=script&lang=js&"
export * from "./preview-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports